(function () {
  if (window.omniTrack) return;

  var dlQueue = [];
  var dlTimer = null;
  var dlTicks = 0;

  function gtagArgs() {
    return arguments;
  }

  function gaConfigured() {
    var dl = window.dataLayer;
    if (!dl) return false;
    for (var i = 0; i < dl.length; i++) {
      if (dl[i] && dl[i][0] === 'config') return true;
    }
    return false;
  }

  function pushDataLayer(args) {
    window.dataLayer = window.dataLayer || [];
    if (gaConfigured()) {
      window.dataLayer.push(args);
      return;
    }
    dlQueue.push(args);
    if (dlTimer) return;
    dlTimer = setInterval(function () {
      dlTicks++;
      if (!gaConfigured()) {
        if (dlTicks < 150) return;
        clearInterval(dlTimer);
        dlTimer = null;
        dlQueue.length = 0;
        return;
      }
      clearInterval(dlTimer);
      dlTimer = null;
      while (dlQueue.length) window.dataLayer.push(dlQueue.shift());
    }, 200);
  }

  var faFunnel = null;
  try {
    var fa = new URLSearchParams(window.location.search).get('fa');
    if (fa && /^[a-z0-9-]{1,80}$/.test(fa)) {
      faFunnel = fa;
      sessionStorage.setItem('fa_funnel', fa);
    } else {
      var stored = sessionStorage.getItem('fa_funnel');
      if (stored && /^[a-z0-9-]{1,80}$/.test(stored)) faFunnel = stored;
    }
  } catch (e) {}

  if (faFunnel) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gtagArgs('set', 'user_properties', { fa_funnel: faFunnel }));
  }

  var AB_TESTS_STORE = '_ab_tests';
  var AB_WAIT_MS = 1500;
  var abTestsPushed = null;
  var abTestsCurrent = null;
  var abTestsReady = false;
  var abQueue = [];
  var abTimer = null;

  var ROLLOUT_STORE = '_omni_quiz_rollout';
  var ROLLOUT_SESSION = '_omni_quiz_exposed';
  var ROLLOUT_ATTR = 'Quiz Rollout';
  var ROLLOUT_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var ROLLOUT_CART_DELAY_MS = 2500;
  var SITE_ATTR = 'Site Rollout';
  var SITE_SESSION = '_omni_site_exposed';
  var rollout = null;
  var rolloutExposed = false;
  var siteRollout = null;
  var rolloutCartBusy = false;
  var rolloutCartTimer = false;
  var rolloutCartAgain = false;

  function gaPush(eventName, payload) {
    var extra = {};
    var needed = false;
    if (abTestsCurrent && payload.ab_tests === undefined) {
      extra.ab_tests = abTestsCurrent;
      needed = true;
    }
    if (rolloutExposed && payload.quiz_rollout === undefined && String(eventName).indexOf('quiz_') !== 0) {
      extra.quiz_rollout = rollout.label;
      needed = true;
    }
    if (siteRollout && payload.site_rollout === undefined) {
      extra.site_rollout = siteRollout.label;
      needed = true;
    }
    var gaPayload = payload;
    if (needed) {
      gaPayload = {};
      Object.keys(payload).forEach(function (key) {
        gaPayload[key] = payload[key];
      });
      Object.keys(extra).forEach(function (key) {
        gaPayload[key] = extra[key];
      });
    }
    pushDataLayer(gtagArgs('event', eventName, gaPayload));
  }

  function readRolloutExposure() {
    try {
      var stored = JSON.parse(localStorage.getItem(ROLLOUT_STORE) || 'null');
      if (!stored || !rollout || stored.key !== rollout.key) return null;
      if (!(Date.now() - stored.at < ROLLOUT_MAX_AGE_MS)) return null;
      return stored;
    } catch (e) {
      return null;
    }
  }

  function wantedCartAttributes() {
    var wanted = {};
    if (rolloutExposed) wanted[ROLLOUT_ATTR] = rollout.label;
    if (siteRollout) wanted[SITE_ATTR] = siteRollout.label;
    return wanted;
  }

  function ensureRolloutCart() {
    var wanted = wantedCartAttributes();
    if (!Object.keys(wanted).length || typeof fetch !== 'function') return;
    if (rolloutCartBusy) {
      rolloutCartAgain = true;
      return;
    }
    rolloutCartBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart) return null;
        var current = cart.attributes || {};
        var attributes = {};
        Object.keys(wanted).forEach(function (key) {
          if (current[key] !== wanted[key]) attributes[key] = wanted[key];
        });
        if (!Object.keys(attributes).length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () {})
      .then(function () {
        rolloutCartBusy = false;
        if (rolloutCartAgain) {
          rolloutCartAgain = false;
          ensureRolloutCart();
        }
      });
  }

  function scheduleRolloutCart(delay) {
    setTimeout(ensureRolloutCart, delay);
  }

  function startCartChecks() {
    if (rolloutCartTimer) return;
    rolloutCartTimer = true;
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) scheduleRolloutCart(0);
    });
    whenReady(function () {
      scheduleRolloutCart(0);
    });
    whenLoaded(function () {
      scheduleRolloutCart(ROLLOUT_CART_DELAY_MS);
    });
  }

  function whenReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function whenLoaded(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }

  function rolloutTreatmentIds() {
    try {
      var scripts = document.scripts;
      for (var i = 0; i < scripts.length; i++) {
        var text = scripts[i].src ? '' : scripts[i].text;
        if (!text || text.indexOf('rolloutTreatmentIds') === -1) continue;
        var m = text.match(/rolloutTreatmentIds\\?"?\s*:\s*\[([^\]]*)\]/);
        if (m) return m[1].replace(/[^0-9A-Za-z,]/g, '').slice(0, 100);
      }
    } catch (e) {}
    return '';
  }

  function retry(fn, tries) {
    try {
      if (fn()) return;
    } catch (e) {
      return;
    }
    if (tries > 0) setTimeout(function () { retry(fn, tries - 1); }, 500);
  }

  function klaviyoReady() {
    return window.klaviyo && typeof window.klaviyo.push === 'function';
  }

  function onKlaviyoForm(e) {
    try {
      var detail = e && e.detail;
      if (!rolloutExposed || !detail || detail.type !== 'submit') return;
      var meta = detail.metaData || {};
      var email = meta.$email || meta.email || '';
      omniTrack('email_captured', { source: 'klaviyo_form', form_id: String(detail.formId || '') });
      if (email && klaviyoReady()) window.klaviyo.push(['identify', { $email: email, quiz_rollout: rollout.label }]);
    } catch (err) {}
  }

  function markRolloutExposed(at) {
    var previous = readRolloutExposure();
    if (!rolloutExposed) window.addEventListener('klaviyoForms', onKlaviyoForm);
    rolloutExposed = true;
    try {
      localStorage.setItem(ROLLOUT_STORE, JSON.stringify({ key: rollout.key, arm: rollout.arm, at: at }));
    } catch (e) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gtagArgs('set', 'user_properties', { quiz_rollout: rollout.label }));
    var label = rollout.label;
    retry(function () {
      if (typeof window.clarity !== 'function') return false;
      window.clarity('set', 'quiz_rollout', label);
      return true;
    }, 20);
    startCartChecks();
    if (previous && previous.arm !== rollout.arm) {
      omniTrack('quiz_rollout_switch', { from_arm: previous.arm, quiz_rollout: rollout.label }, true);
    }
  }

  function omniSetRollout(key, arm) {
    if (rollout) return;
    key = String(key || '').trim().toLowerCase();
    if (!/^[a-z0-9-]{1,30}$/.test(key) || (arm !== 'control' && arm !== 'treatment')) {
      if (window.console) console.warn('[omni] quiz rollout ignored: key must be 1-30 of a-z 0-9 -, arm control|treatment', key, arm);
      return;
    }
    rollout = { key: key, arm: arm, label: key + ':' + (arm === 'treatment' ? 't' : 'c') };
    var stored = readRolloutExposure();
    if (stored) markRolloutExposed(stored.at);
  }

  function omniRolloutExpose(quiz) {
    if (!rollout) return null;
    markRolloutExposed(Date.now());
    var seen = null;
    try {
      seen = sessionStorage.getItem(ROLLOUT_SESSION);
    } catch (e) {}
    if (seen !== rollout.label) {
      try {
        sessionStorage.setItem(ROLLOUT_SESSION, rollout.label);
      } catch (e) {}
      omniTrack('quiz_exposed', { quiz: quiz || '', rollout_tid: rolloutTreatmentIds(), quiz_rollout: rollout.label }, true);
      var label = rollout.label;
      retry(function () {
        if (!klaviyoReady()) return false;
        window.klaviyo.push(['identify', { quiz_rollout: label }]);
        return true;
      }, 20);
    }
    return rollout.arm;
  }

  function omniRollout() {
    return rollout ? { key: rollout.key, arm: rollout.arm, label: rollout.label, exposed: rolloutExposed } : null;
  }

  function omniSetSiteRollout(key, arm) {
    if (siteRollout) return;
    key = String(key || '').trim().toLowerCase();
    if (!/^[a-z0-9-]{1,30}$/.test(key) || (arm !== 'control' && arm !== 'treatment')) {
      if (window.console) console.warn('[omni] site rollout ignored: key must be 1-30 of a-z 0-9 -, arm control|treatment', key, arm);
      return;
    }
    siteRollout = { key: key, arm: arm, label: key + ':' + (arm === 'treatment' ? 't' : 'c') };
    var label = siteRollout.label;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(gtagArgs('set', 'user_properties', { site_rollout: label }));
    retry(function () {
      if (typeof window.clarity !== 'function') return false;
      window.clarity('set', 'site_rollout', label);
      return true;
    }, 20);
    startCartChecks();
    var seen = null;
    try {
      seen = sessionStorage.getItem(SITE_SESSION);
    } catch (e) {}
    if (seen !== label) {
      try {
        sessionStorage.setItem(SITE_SESSION, label);
      } catch (e) {}
      whenReady(function () {
        omniTrack('site_exposed', { site_rollout: label, page_type: document.body ? document.body.getAttribute('data-page-type') || '' : '' }, true);
      });
    }
  }

  function omniSiteRollout() {
    return siteRollout ? { key: siteRollout.key, arm: siteRollout.arm, label: siteRollout.label } : null;
  }

  function flushAbQueue() {
    abTestsReady = true;
    if (abTimer) {
      clearTimeout(abTimer);
      abTimer = null;
    }
    while (abQueue.length) {
      var queued = abQueue.shift();
      gaPush(queued.name, queued.payload);
    }
  }

  function omniSetAbTests(value) {
    var next = value && /^[0-9a-f]{8}(,[0-9a-f]{8}){0,3}$/.test(value) ? value : null;
    try {
      if (next) localStorage.setItem(AB_TESTS_STORE, next);
      else localStorage.removeItem(AB_TESTS_STORE);
    } catch (e) {}
    if (next !== abTestsPushed && (next || abTestsPushed !== null)) {
      abTestsPushed = next;
      abTestsCurrent = next;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(gtagArgs('set', 'user_properties', { ab_tests: next || '' }));
    }
    flushAbQueue();
  }

  try {
    var cachedAbTests = localStorage.getItem(AB_TESTS_STORE);
    if (cachedAbTests) omniSetAbTests(cachedAbTests);
  } catch (e) {}

  function omniTrack(eventName, params, immediate) {
    var payload = params || {};
    var plain = {};
    Object.keys(payload).forEach(function (key) {
      if (typeof payload[key] !== 'function') plain[key] = payload[key];
    });
    try {
      if (abTestsReady || immediate) {
        gaPush(eventName, payload);
      } else {
        abQueue.push({ name: eventName, payload: payload });
        if (!abTimer) abTimer = setTimeout(flushAbQueue, AB_WAIT_MS);
      }
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, plain);
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
        Object.keys(plain).forEach(function (key) {
          window.clarity('set', eventName + '_' + key, String(plain[key]));
        });
      }
    } catch (e) {}
  }

  function lower(v) {
    return String(v == null ? '' : v).trim().toLowerCase();
  }

  function normPack(v) {
    var m = lower(v).match(/([123])\s*x/);
    return m ? m[1] + 'x' : lower(v);
  }

  function normPurchase(v) {
    var s = lower(v).replace(/[\s-]+/g, '_');
    if (s === 'subscription' || s === 'subscribe' || s === 'sub') return 'subscription';
    if (s === 'one_time' || s === 'onetime' || s === 'otp' || s === 'once') return 'one_time';
    return s;
  }

  function checkedValue(root, selector, attrs) {
    if (!selector) return '';
    var el = root.querySelector(selector + ':checked') || root.querySelector(selector + '.selected');
    if (!el) return '';
    for (var i = 0; i < attrs.length; i++) {
      var v = el.getAttribute(attrs[i]);
      if (v) return v;
    }
    return el.value || '';
  }

  function omniBuyboxBind(root, cfg) {
    try {
      bindBuybox(root, cfg);
    } catch (e) {}
  }

  function bindBuybox(root, cfg) {
    if (!root || !cfg || root.__omniBuybox) return;
    root.__omniBuybox = true;

    function read() {
      var sel = cfg.read
        ? cfg.read()
        : {
            flavor: checkedValue(root, cfg.flavor, ['data-flavor']),
            pack: checkedValue(root, cfg.pack, ['data-pack', 'data-pack-title', 'data-title']),
            purchase_type: cfg.purchase ? checkedValue(root, cfg.purchase, ['data-offer']) || 'subscription' : 'subscription'
          };
      return {
        flavor: lower(sel.flavor),
        pack: normPack(sel.pack),
        purchase_type: normPurchase(sel.purchase_type),
        buybox: cfg.buybox
      };
    }

    function key(p) {
      return p.flavor + '|' + p.pack + '|' + p.purchase_type;
    }

    var last = key(read());

    function onSelect(e) {
      if (!e.isTrusted) return;
      var p = read();
      var k = key(p);
      if (k === last) return;
      last = k;
      window.omniTrack('buybox_select', p);
    }

    function onCta(e) {
      if (!e.isTrusted) return;
      var btn = null;
      var oneTime = false;
      if (cfg.cta) btn = e.target.closest(cfg.cta);
      if (!btn && cfg.otpCta) {
        btn = e.target.closest(cfg.otpCta);
        oneTime = !!btn;
      }
      if (!btn || !root.contains(btn)) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var p = read();
      if (oneTime) p.purchase_type = 'one_time';
      p.cta = btn.getAttribute('data-cta') || 'add_to_cart';
      window.omniTrack('cta_click', p);
    }

    function snapshot(e) {
      if (e.isTrusted) last = key(read());
    }

    function safe(fn) {
      return function (e) {
        try {
          fn(e);
        } catch (err) {}
      };
    }

    root.addEventListener('pointerdown', safe(snapshot), true);
    root.addEventListener('keydown', safe(snapshot), true);
    root.addEventListener('change', safe(onSelect));
    root.addEventListener('click', safe(onSelect));
    root.addEventListener('click', safe(onCta), true);
  }

  window.omniTrack = omniTrack;
  window.omniBuyboxBind = omniBuyboxBind;
  window.omniSetAbTests = omniSetAbTests;
  window.omniSetRollout = omniSetRollout;
  window.omniRolloutExpose = omniRolloutExpose;
  window.omniRollout = omniRollout;
  window.omniSetSiteRollout = omniSetSiteRollout;
  window.omniSiteRollout = omniSiteRollout;
})();
